
//import {getCookie, setCookie, checkCookieAndSet} from "../cookieFunctions";
  function productCalculator(){
  //RESET BUTTON
  /*
  const totalHoursField = document.getElementById('totalHours');
  const totalCostField = document.getElementById('totalCost');
  const nettSellTotalField = document.getElementById('nettSellTotal');
  const nettSellHourlyField = document.getElementById('nettSellHourly');
*/
  const totalCostField = document.getElementsByClassName('totalCost');
  const totalHoursField = document.getElementsByClassName('totalHours');
  const nettSellTotalField = document.getElementsByClassName('nettSellTotal');
  const nettSellHourlyField = document.getElementsByClassName('nettSellHourly');
  const markupSpan = document.getElementsByClassName('markupSpan');

  const discountSpan = document.getElementsByClassName('discountSpan');
  const fieldChecked = document.getElementsByClassName("inputFieldChecked");
  const inputFieldCost = document.getElementsByClassName("inputFieldCost");
  const discountPriceArray = document.getElementById("priceDeals")
  //hourlycost
  //nettSellTotal
  const hourlyCostField = intValues(document.getElementById('hourlycost').dataset.hourlycost);
  const markUpField = intValues(document.getElementById('MarkUp').value);
  const disountField = intValues(document.getElementById('discount').value);

  const inputFieldsArray = document.getElementById('inputFieldsArray');

  const featureFieldsArray = document.getElementById('standardFieldsArray');
  const formCheck = document.getElementsByClassName("priceCheck");

  let totalFeatureTime = 0;
  let totalHourlyTimes = 0;
  let markupPercentage = markUpField;
  let disountPercentage = disountField;

  console.log(markupPercentage);
  console.log(disountPercentage);

    //This loops through any input changes within form and calls function rebuildArray()
    function rebuilFeatureddArray(){

    const totalFeaturesArray= [];

    if(featureFieldsArray){
    for (var i = 0, n = formCheck.length; i <= n; i = i + 1) {
      // for (var c = 0, f = i; c <= f; c = c + 1) {
        var checkedPrice = fieldChecked[i];
        if(typeof checkedPrice !== 'undefined' && checkedPrice.checked){
          var intFeaturedPrice = intValues(inputFieldCost[i].value);
          //addUpPrices(intFeaturedPrice);
          totalFeaturesArray.push(intFeaturedPrice);
        }
       // }
      }
      var combineFeatures = combineInt(totalFeaturesArray);
      totalFeatureTime = combineFeatures;
      getTotalCost();
    }
    }

        //This loops through any input changes within form and calls function rebuildArray()
  if(featureFieldsArray){
  var featureTags = featureFieldsArray.getElementsByTagName("input");
  for (var i = 0, n = featureTags.length; i < n; i = i + 1) {
    featureTags[i].addEventListener('input', function (evt) {
      rebuilFeatureddArray();
    });
   }
  }


  //This loops through any input changes within form and calls function rebuildArray()
   if(discountPriceArray){
      var discountPriceTags = discountPriceArray.getElementsByTagName("input");
       for (var i = 0, n = discountPriceTags.length; i < n; i = i + 1) {
        discountPriceTags[i].addEventListener('input', function (evt) {
       
          var fieldId  = this.id;
          if(fieldId == 'MarkUp'){
            markupPercentage = intValues(this.value);
          }

          if(fieldId == 'discount'){
            disountPercentage = intValues(this.value);
          }
          
          getTotalCost();
        });
     }
    }

  //create array from all input fields within a 
  //#inputFieldsArray and combine them using function combineInt()
  function rebuildArray(){

    const timesArray = [];
  
    if(inputFieldsArray){

    var tags = inputFieldsArray.getElementsByTagName("input");
    for (var i = 0, n = tags.length; i < n; i = i + 1) {
      var intValue = intValues(tags[i].value)
      timesArray.push(intValue);
    }
    var combinedTimes = combineInt(timesArray);
    totalHourlyTimes = combinedTimes;
    console.log(totalHourlyTimes);
    //addToInput(totalHoursField, combinedTimes);
    getTotalCost();
  }
  }

  //Adds up all arrays in timesArray it is always called after rebuildArray()
  function combineInt(valueArray){

    const sum = valueArray.reduce((partialSum, a) => partialSum + a, 0);

    return sum;
    //totalHourlyCost.push(sum);
    //getTotalCost();
    //getTotalCost();
    //getTotalCost(sum, hourlyCostField);
  }

  //This loops through any input changes within form and calls function rebuildArray()
  if(inputFieldsArray){
  var tags = inputFieldsArray.getElementsByTagName("input");
  for (var i = 0, n = tags.length; i < n; i = i + 1) {
    tags[i].addEventListener('input', function (evt) {
      rebuildArray();
    });
  }
}


  /***** Function to call INT and add input fileds */
  function addToInput(field, value){

        field.textContent = value;

  }

  function addToInputClass(field, value){

    console.log(field);
    for (var i = 0, n = field.length; i < n; i = i + 1) {
        field[i].textContent = value;
    }
  }

  function getTotalCost(){

    var totalHoursCombined = totalFeatureTime + totalHourlyTimes;
    addToInputClass(totalHoursField, totalHoursCombined);
   
    var totalPriceHours = multiplyValue(totalHoursCombined, hourlyCostField);

    addToInputClass(nettSellTotalField, totalPriceHours);
 
    var hourlyCostMarkUp = addMarkUp(hourlyCostField);
    var hourlyCostMarkUp = addDiscount(hourlyCostMarkUp);
    addToInputClass(nettSellHourlyField, (Math.round(hourlyCostMarkUp * 100) / 100).toFixed(2));

    var totalWithMarkUp = addMarkUp(totalPriceHours);
    var totalWithMarkUp = addDiscount(totalWithMarkUp);
    addToInputClass(totalCostField, (Math.round(totalWithMarkUp * 100) / 100).toFixed(2));


  }

  function multiplyValue(x, y){
   return  x * y;
  }

  function addMarkUp(totalCost){

    if(markupPercentage > 0){
      addToInputClass(markupSpan, ("+"+markupPercentage+"%"));
    }else{
      addToInputClass(markupSpan, '');
    }

    var percentage =  totalCost / 100 * markupPercentage;
    var totalMarkupCost = totalCost + percentage;
    return totalMarkupCost;
  }


  function addDiscount(totalCost){


        if(disountPercentage > 0){
          addToInputClass(discountSpan, ("-"+disountPercentage+"%"));
       }else{
        addToInputClass(discountSpan, '');
       }
    
   
    var percentage =  totalCost / 100 * disountPercentage;
    var totalMarkupCost = totalCost - percentage;
    return totalMarkupCost;
  }

  function intValues(value){
    if (value == '') {
      value = 0
    }
    var valueInt = parseInt(value);
    return(valueInt)
  }

  //Always call
  rebuildArray();
  rebuilFeatureddArray();
  getTotalCost();
}

window.onload = (event) => {
productCalculator();
}